import Vue from 'vue'
import Router from 'vue-router'
import Main from './components/Main'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Main,
      children: [
        {
          path: '',
          name: 'index',
          component: () => import( '@/views/index/index'),
          meta: {
            title: '首页',
            head: '广州淘通决策数据看板'
          }
        }
      ]
    },
    {
      path: '/monthly',
      component: Main,
      children: [
        {
          path: '',
          name: 'monthly',
          component: () => import( '@/views/monthly/index'),
          meta: {
            title: '月报',
            head: '淘通运营月报表'
          }
        }
      ]
    },
    {
      path: '/monthly-detail',
      component: Main,
      children: [
        {
          path: '',
          name: 'monthly-detail',
          component: () => import( '@/views/monthly/monthly'),
          meta: {
            title: '分月明细',
            head: '淘通运营月报表'
          }
        }
      ]
    },
    {
      path: '/classify',
      component: Main,
      children: [
        {
          path: '',
          name: 'classify',
          component: () => import( '@/views/monthly/classify'),
          meta: {
            title: '分类明细',
            head: '淘通运营月报表'
          }
        }
      ]
    },
    {
      path: '/day',
      component: Main,
      children: [
        {
          path: '',
          name: 'day',
          component: () => import( '@/views/day/index'),
          meta: {
            title: '日报',
            head: '淘通运营日报表'
          }
        }
      ]
    },
    {
      path: '/day-gz',
      component: Main,
      children: [
        {
          path: '',
          name: 'day-gz',
          component: () => import( '@/views/day/day-gz'),
          meta: {
            title: '日报',
            head: '淘通运营日报表'
          }
        }
      ]
    },
    {
      path: '/day-sh',
      component: Main,
      children: [
        {
          path: '',
          name: 'day-sh',
          component: () => import( '@/views/day/day-sh'),
          meta: {
            title: '日报',
            head: '淘通运营日报表'
          }
        }
      ]
    },
    {
      path: '/day-bj',
      component: Main,
      children: [
        {
          path: '',
          name: 'day-bj',
          component: () => import( '@/views/day/day-bj'),
          meta: {
            title: '日报',
            head: '淘通运营日报表'
          }
        }
      ]
    },
    {
      path: '/logistics-day',
      component: Main,
      children: [
        {
          path: '',
          name: 'logistics-day',
          component: () => import( '@/views/logistics/index'),
          meta: {
            title: '物流日报',
            head: '淘通物流日报表'
          }
        }
      ]
    },
    {
      path: '/demo',
      name: 'demo',
      component: () => import( '@/views/demo/index.vue'),
      meta: {
        title: 'demo',
        head: 'demo'
      }
    },
    {
      path: '/order-operation',
      name: 'order-operation',
      component: () => import( '@/views/order-operation/index.vue'),
      meta: {
        title: '每日鲜语订单系统',
        head: '每日鲜语订单系统'
      }
    },
    {
      path: '/dove',
      name: 'dove',
      component: () => import( '@/views/dove/index.vue'),
      meta: {
        title: '德芙活动',
        head: '德芙活动'
      }
    },
    {
      path: '/prohibited',
      name: 'prohibited',
      component: () => import( '@/views/prohibited/index'),
      meta: {
        title: '淘通科技广告违禁词',
        head: '淘通科技广告违禁词'
      }
    },
    {
      path: '/tmallelves',
      name: 'tmallelves',
      component: () => import( '@/views/tmallelves/index'),
      meta: {
        title: '美孚',
        head: '美孚'
      }
    },
    {
      path: '/xiaotaomama',
      name: 'xiaotaomama',
      component: () => import( '@/views/xiaotaomama/index'),
      meta: {
        title: '小陶妈妈',
        head: '小陶妈妈'
      },
      children: [
        {
          path: 'ranking',
          name: 'xiaotaomamaRanking',
          component: () => import( '@/views/xiaotaomama/ranking/index'),
          meta: {
            title: '排行榜',
            head: '排行榜'
          }
        },
        {
          path: 'information',
          name: 'xiaotaomamaInformation',
          component: () => import( '@/views/xiaotaomama/information/index'),
          meta: {
            title: '提交资料',
            head: '提交资料'
          }
        },
        {
          path: 'wechat',
          name: 'xiaotaomamaWechat',
          component: () => import( '@/views/xiaotaomama/wechat/index'),
          meta: {
            title: '关注公众号',
            head: '关注公众号'
          }
        }
      ]
    },
    {
      path: '/snickersvoice',
      name: 'snickerSvoice',
      component: () => import( '@/views/snickers-voice/index'),
      meta: {
        title: '士力架',
        head: '士力架'
      }
    }
  ]
})
